module.exports = __webpack_public_path__ + "img/12_12.159310e3.png";